"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-cms/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addList = addList;
exports.aloneFaq = aloneFaq;
exports.changeFaq = changeFaq;
exports.changeOn = changeOn;
exports.changeSeq = changeSeq;
exports.delefaq = delefaq;
exports.getLists = getLists;
var _request = _interopRequireDefault(require("@/utils/request"));
//查询FAQ条目信息
function getLists(data) {
  return (0, _request.default)({
    url: 'cms/faq/item/list',
    method: 'POST',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//新增FAQ条目信息
function addList(data) {
  return (0, _request.default)({
    url: 'cms/faq/item',
    method: 'POST',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//修改FAQ条目上线下线
function changeOn(data, id) {
  return (0, _request.default)({
    url: 'cms/faq/item/line/' + id,
    method: 'put',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//修改FAQ条目序号
function changeSeq(data, id) {
  return (0, _request.default)({
    url: 'cms/faq/item/seq/' + id,
    method: 'put',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//查询单个FAQ条目信息
function aloneFaq(id) {
  return (0, _request.default)({
    url: 'cms/faq/item/' + id,
    method: 'get',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    }
  });
}

//修改FAQ条目信息
function changeFaq(id, data) {
  return (0, _request.default)({
    url: 'cms/faq/item/' + id,
    method: 'put',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//删除FAQ条目信息
function delefaq(id) {
  return (0, _request.default)({
    url: 'cms/faq/item/' + id,
    method: 'DELETE',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    }
  });
}